// extracted by mini-css-extract-plugin
module.exports = {"color-white":"#fff","overlay":"DisabledOverlay_overlay__HnDoy"};